function Search(container) {
  var sectionId = container.getAttribute('data-section-id');
  var hs = document.getElementById('search-' + sectionId);
  LiveSearch(container);  
}

document.addEventListener('Section:Loaded', function(myFunction){
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  if(sectionType === 'search'){
    Search(sectionContainer);
  }
})

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  if(sectionType === 'search' && !sectionContainer.classList.contains('ignore')){
    Search(sectionContainer);
    sectionContainer.classList.add('ignore');
  }
})

theme.Search = (function() {
  function Search(container) {
    var sectionId = container.getAttribute('data-section-id');
    LiveSearch(container);
    if (theme.settings.cart) {
      Cart(container);
    }
    Swatches(container); 
  }
  return Search;
})(); 